import { useStateMachine } from "little-state-machine";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import IMapWorkOrderPaneProps from "interfaces/components/Map/IMapWorkOrderPaneProps";
import { getWorkOrderDueDateClassName } from "helpers/workOrderUtils";
import { format2DateWithTime } from "helpers/DateUtils";
import { SourceEnum } from "modules/sourceEnum";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";

import { updateCompleteWorkOrderPageOrigination } from "actions/updateCompleteWorkOrderPageOrigination";
import { updateRaiseWorkOrderDetails } from "actions/updateRaiseWorkOrderDetails";
import { updateViewWorkOrderPageOrigination } from "actions/updateViewWorkOrderPageOrigination";

const MapWorkOrderPane = (props: IMapWorkOrderPaneProps): any => {
  const { actions } = useStateMachine({
    updateRaiseWorkOrderDetails,
    updateViewWorkOrderPageOrigination,
    updateCompleteWorkOrderPageOrigination
  });
  const { workOrder, isVehicle, sourceId } = props;
  const source = SourceEnum.Map;
  const sourceType = isVehicle ? SourceEnum.Vehicle : SourceEnum.HwrcSite;
  const {
    containerWasteType,
    containerSize,
    id,
    status,
    disposalSite,
    collectorName,
    collectorType
  } = workOrder;

  const dueDate = new Date(workOrder.dueDate);

  const configureOrigination = () => {
    actions.updateViewWorkOrderPageOrigination(RoutePathsEnum.Map);
    actions.updateCompleteWorkOrderPageOrigination(
      RoutePathsEnum.WorkOrderView
    );
  };

  return (
    <>
      <Row>
        <Col data-testid={`workorder-container-${id}`}>
          <strong>
            {containerWasteType}
            {" "}
            {containerSize}
            {" "}
            {id ? (
              <Link
                data-testid={`workorder-link-${id}`}
                style={{ textDecoration: "none" }}
                to={`${RoutePathsEnum.WorkOrderView}/${id}/${source}/${sourceType}/${sourceId}`}
                onClick={configureOrigination}
              >
                {id}
              </Link>
            ) : null}
          </strong>
          <br />
        </Col>
      </Row>

      {!isVehicle && (
        <Row data-testid={`workorder-collector-${id}`}>
          <Col>
            {collectorName && `${collectorName} `}
            {collectorType && collectorType}
          </Col>
        </Row>
      )}

      <Row data-testid={`workorder-status-${id}`}>
        <Col>
          {status}
          {" - "}
          <span
            data-testid={`workorder-duedate-${id}`}
            className={getWorkOrderDueDateClassName(dueDate!)}
          >
            {format2DateWithTime(dueDate)}
          </span>
        </Col>
      </Row>

      <Row className="mb-3" data-testid={`workorder-disposalsite-${id}`}>
        <Col>{disposalSite}</Col>
      </Row>
    </>
  );
};
export default MapWorkOrderPane;
